import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { FormInstance } from 'antd/es/form';
import produce from 'immer';
import { RootState } from 'modules';
import {
  StyledInputWrapper,
  StyledAddedOptionWrapper,
} from 'components/learning/quiz/components/QuizChoiceOption';
import { TAddedListAnswer, EQuizType } from 'modules/learning';
import { addAnswer } from 'modules/learning/createQuiz';
import { Form, Button, Input, InputNumber, Switch } from 'antd';
import { PrimaryColor, PlusOutlineIcon, MinusOutlineIcon } from 'GlobalStyles';

const ListTypeAnswer = ({ form, quizTypeName }: { form: FormInstance; quizTypeName: string }) => {
  const [listAnswerState, setListAnswerState] = useState<Array<TAddedListAnswer>>([]);
  const dispatch = useDispatch();
  const quizState = useSelector((store: RootState) => store.createQuizReducer);
  const { operation, id }: { operation: string; id: string } = useParams();

  const onClickAddOption = () => {
    const optionContent = form.getFieldValue('add_answer');
    const optionNumber = form.getFieldValue('add_answer_number');
    setListAnswerState([
      ...listAnswerState,
      { content_number: optionNumber, content: optionContent, is_shown: false },
    ]);
    form.setFieldsValue({
      add_answer: undefined,
      add_answer_number: undefined,
    });
  };

  const onClickDeleteOption = (number: number, content: string, idx: number) => {
    const filteredOptionList = listAnswerState.filter((el: TAddedListAnswer, index: number) => {
      return index !== idx;
    });
    setListAnswerState(filteredOptionList);
  };

  const handleIsShownChecked = (checked: boolean, el: TAddedListAnswer) => {
    const nextState = produce(listAnswerState, (draft) => {
      const targetAnswer = draft.find(
        (element) => element.content === el.content && element.content_number === el.content_number,
      );
      if (targetAnswer) {
        targetAnswer.is_shown = checked;
      }
    });
    setListAnswerState(nextState);
  };

  useEffect(() => {
    if (listAnswerState) {
      const formattedAnswerList = listAnswerState.map((el: TAddedListAnswer) => {
        return { ...el, parent: null, column_index: null, depth: null };
      });
      dispatch(addAnswer(quizTypeName, formattedAnswerList));
    }
  }, [listAnswerState]);

  useEffect(() => {
    if (id && quizState.answer_type === EQuizType.List) {
      setListAnswerState(quizState.quiz_answer);
    }
  }, [quizState.id]);

  return (
    <>
      {/* 정답 작성 */}
      <StyledInputWrapper>
        <Form.Item name={'add_answer_number'} style={{ width: '10%' }}>
          <InputNumber className='option_input' placeholder='번호' />
        </Form.Item>
        <Form.Item name={'add_answer'} style={{ width: '75%' }}>
          <Input className='option_input' placeholder='선택지 입력창' />
        </Form.Item>
        <Button className='list-plus-button' onClick={onClickAddOption}>
          <PlusOutlineIcon fill={PrimaryColor} />
        </Button>
      </StyledInputWrapper>
      {/* 작성한 답안 리스트 */}
      <StyledAddedOptionWrapper>
        {listAnswerState.length > 0 &&
          listAnswerState.map((el: TAddedListAnswer, idx: number) => {
            return (
              <div key={el.content} style={{ display: 'flex', alignItems: 'center' }}>
                <Button
                  className='list-minus-button'
                  onClick={() => onClickDeleteOption(el.content_number, el.content, idx)}
                >
                  <MinusOutlineIcon fill={PrimaryColor} />
                </Button>
                <Button className='btn-disabled'>{`${el.content_number}. ${el.content}`}</Button>
                <Switch
                  checked={el.is_shown}
                  onChange={(checked) => handleIsShownChecked(checked, el)}
                  checkedChildren='ON'
                  unCheckedChildren='OFF'
                />
              </div>
            );
          })}
      </StyledAddedOptionWrapper>
    </>
  );
};

export default ListTypeAnswer;
